import type { StageColour } from '@playerbase/types';

// Tailwind class fragments per palette colour. Both maps reference the
// brand tokens defined in packages/ui/src/tokens/colors.css, so light /
// dark mode and any future theme tweaks happen via CSS variables, not
// here. Strings stay literal for Tailwind's purger.

export const STAGE_BADGE_CLASSES: Readonly<Record<StageColour, string>> = {
  gray: 'bg-stage-gray-bg text-stage-gray-text border-stage-gray-border',
  red: 'bg-stage-red-bg text-stage-red-text border-stage-red-border',
  orange: 'bg-stage-orange-bg text-stage-orange-text border-stage-orange-border',
  yellow: 'bg-stage-yellow-bg text-stage-yellow-text border-stage-yellow-border',
  green: 'bg-stage-green-bg text-stage-green-text border-stage-green-border',
  blue: 'bg-stage-blue-bg text-stage-blue-text border-stage-blue-border',
  purple: 'bg-stage-purple-bg text-stage-purple-text border-stage-purple-border',
  pink: 'bg-stage-pink-bg text-stage-pink-text border-stage-pink-border',
};

// Solid swatch fills used in the colour-picker popover and the row's
// colour chip. Borders are a darker shade of the same colour so the
// swatch stays legible on both light and dark surfaces.
export const STAGE_SWATCH_CLASSES: Readonly<Record<StageColour, string>> = {
  gray: 'bg-stage-gray-swatch border-stage-gray-swatch-border',
  red: 'bg-stage-red-swatch border-stage-red-swatch-border',
  orange: 'bg-stage-orange-swatch border-stage-orange-swatch-border',
  yellow: 'bg-stage-yellow-swatch border-stage-yellow-swatch-border',
  green: 'bg-stage-green-swatch border-stage-green-swatch-border',
  blue: 'bg-stage-blue-swatch border-stage-blue-swatch-border',
  purple: 'bg-stage-purple-swatch border-stage-purple-swatch-border',
  pink: 'bg-stage-pink-swatch border-stage-pink-swatch-border',
};

export const STAGE_COLOUR_LABELS: Readonly<Record<StageColour, string>> = {
  gray: 'Gray',
  red: 'Red',
  orange: 'Orange',
  yellow: 'Yellow',
  green: 'Green',
  blue: 'Blue',
  purple: 'Purple',
  pink: 'Pink',
};
